export { default } from './LayoutHeaderNotificationsContent';
